import { createApp } from 'vue';
import cmpBlogCategoryPaginator from '../vue/blog/BlogCategoryPaginator.vue';

window.Blog = (function() {
	const initCategoryPaginators = () => {
		const sections = document.querySelectorAll('.blog-category-section');

		return Array.from(sections)
			.map((section) => {
				const mountElement = section.querySelector('.blog-category-paginator-mount');

				if (mountElement == null) {
					return null;
				}

				const component = createApp(cmpBlogCategoryPaginator, {
					fetchUrlBase: section.dataset.fetchUrlBase ?? '',
					targetId: section.dataset.targetId ?? '',
					initialPageIndex: Number(section.dataset.pageIndex ?? 0),
					pageSize: Number(section.dataset.pageSize ?? 1),
					nrRecords: Number(section.dataset.nrRecords ?? 0)
				});

				return component.mount(mountElement);
			})
			.filter(x => x != null);
	};

	document.addEventListener('DOMContentLoaded', initCategoryPaginators);

	return {
		initCategoryPaginators
	};
})();